import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {CoinsProductInterface, CoinsSellerInterface} from "@/modules/action-points/interfaces";
import BeforeBuyCoinsEvent from "@/modules/action-points/ events/BeforeBuyCoinsEvent";
import {Team} from "@/modules/team/entity";
import AfterBuyCoinsEvent from "@/modules/action-points/ events/AfterBuyCoinsEvent";
import WebMockCoinsProduct from "./WebMockCoinsProduct";

@injectable()
export default class WebMockCoinsSeller implements CoinsSellerInterface {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  async buy(product: CoinsProductInterface) {
    const team = await Team.current();

    await this.em.emitAsync(new BeforeBuyCoinsEvent(team, product));

    console.log(`Web: ${product.coins} coins bought via ${product.name}.`);

    await this.em.emitAsync(new AfterBuyCoinsEvent(team, product));

    return true;
  }

  getProducts(): Promise<CoinsProductInterface[]> {
    return Promise.resolve([
      new WebMockCoinsProduct(10, 1, '10. Coins', '10. Coins description'),
      new WebMockCoinsProduct(50, 4, '50. Coins', '50. Coins description'),
      new WebMockCoinsProduct(100, 7, '100. Coins', '100. Coins description'),
      new WebMockCoinsProduct(500, 30, '500. Coins', '500. Coins description'),
    ]);
  }
}
